/* eslint-disable eqeqeq */
import { Download, Loader2 } from "lucide-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import MainBody from "../../../components/MainBody/MainBody";
import DropDownButton from "../../../components/DropDownButton";
import { API, fileUpload } from "../../../config";
import { formatDateTime, formatNumber } from "../../../lib/Misc";
import SubAssetSelect from "../../../components/SubAssetSelect";
import { useReactToPrint } from "react-to-print";
import { Button } from "../../../components/ui/button";

const SubAssetSummary = ({ trustId, id, subAsset, assetId }) => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subAssetId, setSubAssetId] = useState(id);

  console.log(reportData);

  const [subAssetLoading, setSubAssetLoading] = useState(false);
  const [subAssetListing, setSubAssetListing] = useState([]);

  const [subAssetList, setSubAssetList] = useState(
    subAsset
      ? [
          {
            ...subAsset,
            value: subAsset.id,
            label: subAsset?.name ? subAsset.name : "",
          },
        ]
      : []
  );

  const fetchSubAssetItem = useCallback(async () => {
    try {
      setLoading(true);
      const formData = new FormData();

      formData.append(`subAsset_id`, subAssetId);
      formData.append("trust_id", trustId ? trustId : "");

      formData.append("export", 1);
      const { data } = await fileUpload(
        `${API.SUB_ASSET_STATEMENT_REPORT}`,
        formData
      );
      setReportData(data?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setReportData([]);
    }
  }, [subAssetId, trustId]);

  useEffect(() => {
    fetchSubAssetItem();
  }, [fetchSubAssetItem]);

  const handleExport = async (format) => {
    if (trustId) {
      try {
        setLoading(true);
        const formData = new FormData();

        formData.append(`subAsset_id`, subAssetId);

        formData.append("trust_id", trustId ? trustId : "");

        formData.append("export", 1);

        const { data } = await fileUpload(
          `${API.SUB_ASSET_STATEMENT_REPORT}`,
          formData
        );
        const export_report_path = data?.data?.file;
        if (export_report_path) {
          var a = document.createElement("a");
          a.href = export_report_path;
          var file = export_report_path.split("/");
          a.setAttribute(
            "download",
            file[file.length - 1] || "transactionsreport.pdf"
          );
          a.setAttribute("target", "_blank");
          document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
          a.click();
          a.remove();
          setLoading(false);
        }
      } catch (e) {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (subAssetList) {
      let subAssetTempListing = subAssetList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name ? item.name : "",
      }));
      setSubAssetListing(subAssetTempListing || []);
    } else {
      setSubAssetListing([]);
    }
  }, [subAssetList]);

  const printRef = useRef(null);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    contentRef: printRef,
    documentTitle: "Statement Report",
    removeAfterPrint: false, // Optional: prevents issues with disappearing modals
  });

  const months = [
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Total",
  ];

  const rentRow = [
    5040, 2520, 2520, 2520, 2520, 2520, 10400, 3790, 2800, 2800, 2800, 2800,
    34730.0,
  ];

  const expenses = [
    {
      label: "Document Preparation",
      values: [0, 0, 0, 0, 0, 0, 33, 0, 0, 0, 0, 0, 33],
    },
    {
      label: "Electrical",
      values: [0, 0, 434.5, 0, 0, 0, 0, 0, 0, 0, 0, 0, 434.5],
    },
    {
      label: "Fire Protection",
      values: [0, 0, 0, 0, 0, 0, 0, 0, 0, 104.5, 0, 0, 104.5],
    },
    {
      label: "General Repair and Maintenance",
      values: [0, 0, 0, 275, 0, 0, 0, 0, 495, 0, 0, 0, 770],
    },
    { label: "Letting Fee", values: Array(13).fill(0) },
    {
      label: "Residential Management Fee",
      values: [
        277.2, 138.6, 138.6, 138.6, 138.6, 138.6, 77, 204.5, 145, 145, 145,
        190.13, 1871.33,
      ],
    },
    {
      label: "Water Rates",
      values: [
        0, 172.79, 0, 178.91, 0, 0, 0, 168.03, 0, 163.82, 0, 170.9, 854.45,
      ],
    },
    {
      label: "Water Rates 1",
      values: [
        0, 172.79, 0, 178.91, 0, 0, 0, 168.03, 0, 163.82, 0, 170.9, 854.45,
      ],
    },
    {
      label: "Water Rates 2",
      values: [
        0, 172.79, 0, 178.91, 0, 0, 0, 168.03, 0, 163.82, 0, 170.9, 854.45,
      ],
    },
    {
      label: "Water Rates 3",
      values: [
        0, 172.79, 0, 178.91, 0, 0, 0, 168.03, 0, 163.82, 0, 170.9, 854.45,
      ],
    },
    {
      label: "Water Rates 4",
      values: [
        0, 172.79, 0, 178.91, 0, 0, 0, 168.03, 0, 163.82, 0, 170.9, 854.45,
      ],
    },
  ];

  // const totalExpenses = Array(13).fill(0);
  // expenses.forEach((exp) => {
  //   exp.values.forEach((val, i) => {
  //     totalExpenses[i] += val;
  //   });
  // });

  const htmlData = (original) => {
    return (
      <table className="w-full border-collapse text-[10px] print:table">
        <tbody>
          <tr>
            <td>
              <div className="print-content mx-auto bg-white text-black font-sans text-[10px] print:w-full">
                {/* Header */}
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <img
                      src="/logo.png"
                      alt="Charlie Brown"
                      className="h-6 mb-1"
                    />
                  </div>
                  <div className="text-right">
                    <p>
                      1/2 Rooty Hill Road South, Rooty Hill, NSW 2766, AUSTRALIA
                      <br />
                      Ph: 02 9853 0650 Fax:
                    </p>
                  </div>
                </div>

                <h2 className="text-sm font-bold border-b border-black mb-2 pb-1">
                  Income & Expenditure Summary
                </h2>

                {/* Client Info */}
                <div className="flex justify-between items-end mb-4">
                  <div>
                    <p>
                      <strong>Dinesh Kumar Babulal Choradiya</strong>
                    </p>
                    <p>7 Egret Close</p>
                    <p>Bella Vista NSW 2153</p>
                  </div>
                  <div>
                    <p>
                      <strong>Date:</strong> 1/07/2024 to 30/06/2025
                    </p>
                  </div>
                </div>

                {/* Section Title */}
                <div className="bg-gray-300 font-bold px-2 py-1 text-sm mb-1">
                  Dinesh Kumar Babulal Choradiya & Vandana Choradiya (ID: 1432)
                </div>

                {/* Owner Contributions */}
                <table className="w-full border-collapse text-[10px] mb-4 table-fixed">
                  <thead>
                    <tr className="">
                      {/* <th className="border border-black px-2 py-1 text-left w-[200px]">
                Owner Contributions
              </th> */}
                      {months.map((m, idx) => (
                        <th key={idx} className=" px-2 py-1 text-right">
                          {m}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td
                        className="bg-gray-400 border-t border-black px-2 py-1 text-end font-bold"
                        colSpan={13}
                      >
                        OPENING BALANCE: $0.00
                      </td>
                    </tr>
                    <tr>
                      <td className="px-2 py-1" colSpan={13}>
                        Owner Contributions
                      </td>
                    </tr>
                    <tr>
                      {Array(13)
                        .fill(0)
                        .map((_, idx) => (
                          <td key={idx} className="px-2 text-right">
                            0.00
                          </td>
                        ))}
                    </tr>
                  </tbody>
                </table>

                {/* Sub Asset Info */}
                <div className="bg-gray-400 font-bold px-2 py-1 text-sm mb-1">
                  Sub Asset
                </div>
                <div className="bg-gray-300 font-medium px-1 py-1 text-xs">
                  8 Dianella Circuit, WOODCROFT, NSW 2767
                </div>

                {/* Income */}
                <table className="w-full border-collapse text-[10px] mb-2 table-fixed">
                  <tbody>
                    <tr>
                      <td className="px-2 py-1 font-bold" colSpan={13}>
                        Sub Asset Income
                      </td>
                    </tr>
                    <tr>
                      <td className="px-2" colSpan={13}>
                        Residential Rent
                      </td>
                    </tr>
                    <tr className="font-semibold">
                      {rentRow.map((val, idx) => (
                        <td key={idx} className="border-b px-2 py-1 text-right">
                          {formatNumber(val.toFixed(2))}
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <td
                        colSpan={13}
                        className="px-2 py-1 italic text-gray-600 text-end"
                      >
                        <span className="normal text-black font-bold">{`$${formatNumber(
                          34730.0
                        )}`}</span>
                        <br />
                        (GST Total: $0.00)
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* Expenses */}
                <table className="w-full border-collapse text-[10px] mb-2 table-fixed border-t-[1.5px] border-black">
                  <tbody>
                    <tr>
                      <td className="px-2 py-1 font-bold" colSpan={13}>
                        Sub Asset Expenses
                      </td>
                    </tr>
                    {expenses.map((item, idx) => (
                      <>
                        <tr key={`${idx}-i`}>
                          <td className="px-2" colSpan={13}>
                            {item.label} (GST Inclusive)
                          </td>
                        </tr>
                        <tr
                          key={idx}
                          className={
                            expenses?.length - 1 === idx ? "border-b" : ""
                          }
                        >
                          {item.values.map((val, id) => (
                            <td key={id} className="px-2 py-1 text-right">
                              {val.toFixed(2)}
                            </td>
                          ))}
                        </tr>
                      </>
                    ))}
                    <tr>
                      <td
                        colSpan={13}
                        className="px-2 py-1 italic text-gray-600 text-end"
                      >
                        <span className="normal text-black font-bold">{`$${formatNumber(
                          34730.0
                        )}`}</span>
                        <br />
                        (GST Total: $0.00)
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="bg-gray-400 text-[10px] italic  font-bold px-2 py-1 text-sm mb-1 text-right">
                  <span className="normal text-black font-bold">{`PROPERTY BALANCE: $${formatNumber(
                    34730.0
                  )}`}</span>
                  <br />
                  (GST Total: $0.00)
                </div>

                {/* Spacer for footer */}
                {/* <div className="print:pb-32"></div> */}

                {/* Footer (Print Only) */}
                {/* <footer className="hidden print:block text-[10px] border-t-[1.5px] border-black pt-2 mt-4 print:fixed print:bottom-0 print:left-0 print:right-0 print:px-6 print:mx-4 print:py-2 bg-white">
            <div className="flex justify-between items-center">
              <div className="mt-1 flex items-center gap-3">
                <img src="/logo.png" alt="Charlie Brown" className="h-6 mb-1" />
                <p>
                  Charlie Brown Real Estate · ABN 65 625 318 812 <br />
                  Corp. Licence Number: 10043735 · Licensee Name & Number: Ajay
                  Kumar 20096206
                </p>
              </div>
              <div className="flex justify-between items-center mt-1 flex-col">
                <p>Generated on {formatDateTime(new Date())}</p>
              </div>
            </div>
          </footer> */}
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot className="print:table-footer-group hidden text-[10px] mt-4 print:mx-4 print:py-2 bg-white">
          <tr>
            <td style={{ height: "20px" }}></td>
          </tr>
          <tr>
            <td className="pt-2 mt-4 border-t border-black">
              <div className="flex justify-between items-center text-[10px]">
                <div className="flex items-center gap-3">
                  <img
                    src="/logo.png"
                    alt="Charlie Brown"
                    className="h-6 mb-1"
                  />
                  <p>
                    Charlie Brown Real Estate · ABN 65 625 318 812 <br />
                    Corp. Licence Number: 10043735 · Licensee Name & Number:
                    Ajay Kumar 20096206
                  </p>
                </div>
                <div className="flex flex-col items-end">
                  <p>Generated on {formatDateTime(new Date())}</p>
                </div>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    );
  };

  return (
    <div className="relative">
      <MainBody
        search={false}
        actionAlign={"between"}
        actionContent={
          <>
            <div className="min-w-0 flex items-center gap-4">
              <div className="relative">
                <SubAssetSelect
                  trustId={trustId}
                  assetId={assetId ? assetId : ""}
                  frameworkData={subAssetListing} // List of subAssets
                  optionType="Sub Asset"
                  handleSelect={(e) => {
                    setSubAssetId(e);
                  }}
                  name="sub_asset_id"
                  disabled={false}
                  initialValue={subAssetId ? subAssetId : ""}
                  setSubAssetList={setSubAssetList} // Update subAsset list as new data loads
                  setSubAssetLoading={setSubAssetLoading} // Control loading state
                  onClear={() => {
                    setSubAssetId("");
                  }}
                  loading={subAssetLoading}
                  clearable={false}
                />
                {subAssetLoading && (
                  <span className="absolute top-2 right-2 animate-spin">
                    <Loader2 width={20} height={20} />
                  </span>
                )}
              </div>
              <div>
                Closing Balance:{" "}
                {subAssetListing?.find((item) => item.id === subAssetId)
                  ?.closing_balance
                  ? `$${formatNumber(
                      Number(
                        subAssetListing?.find((item) => item.id === subAssetId)
                          ?.closing_balance
                      )
                    )}`
                  : "$0.00"}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <DropDownButton
                items={[
                  {
                    label: "PDF",
                    onClick: () => handleExport("pdf"),
                    disabled: loading,
                  },
                  {
                    label: "Excel",
                    onClick: () => handleExport("xlsx"),
                    disabled: loading,
                  },
                ]}
                text={
                  <div className="flex gap-2 items-center">
                    Export <Download size={18} />
                  </div>
                }
              />
            </div>
          </>
        }
        expandList={true}
        className="!p-0 !bg-background"
        loading={loading}
      >
        <>
          <div className="p-6  max-h-[75vh] flex w-full items-center justify-center">
            {/* 👇 Print & Preview Content (SAME DIV) */}
            <div className="rounded-md border w-fit overflow-y-auto max-h-[75vh]">
              <div
                ref={printRef}
                className="bg-white text-black p-4 text-sm m-0 rounded-md"
              >
                {htmlData(true)}
              </div>
            </div>
          </div>
          {/* 👇 Print Button */}
          <div className="mt-4 flex justify-end">
            <Button onClick={handlePrint}>Print</Button>
          </div>
        </>
      </MainBody>
    </div>
  );
};

export default SubAssetSummary;
